import { render, staticRenderFns } from "./ApplicantBulkMessageTarget.vue?vue&type=template&id=bf664c4e"
import script from "./ApplicantBulkMessageTarget.vue?vue&type=script&lang=js"
export * from "./ApplicantBulkMessageTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports